import flatwizard1 from '../assets/images/flatwizard1.webp';
import flatwizard2 from '../assets/images/flatwizard2.webp';
import flatwizard3 from '../assets/images/flatwizard3.webp';
import flatwizard4 from '../assets/images/flatwizard4.webp';

/** Set to false to revert to the classic side-by-side illustration layout. */
export const USE_FLAT_WIZARD_DESIGN = true;

export const wizardIllustrations = [
    flatwizard1,
    flatwizard2,
    flatwizard3,
    flatwizard4,
];

export const wizardIllustrationStyle = {
    maxWidth: '100%',
    maxHeight: '350px',
    objectFit: 'contain',
};

export function pickRandomWizardIllustration() {
    const index = Math.floor(Math.random() * wizardIllustrations.length);
    return wizardIllustrations[index];
}
